import request from "@/utils/request";

export function GetClassTimeInfo(data) {
  return request({
    url: "classTime/Get",
    method: "post",
    data: data,
  });
}

export function SaveClassTimeInfo(data) {
  return request({
    url: "classTime/Save",
    method: "post",
    data: data,
  });
}
